import {useCallback} from 'react';
import {QrCode} from 'lucide-react';
import {Trans, useTranslation} from 'react-i18next';
import {useNavigate} from 'react-router-dom';
import {PATHS} from 'routes/constants';
import Button from 'components/common/Button';
import styles from './styles.module.css';

function IVQRScanView() {
  const {t} = useTranslation('identity-verification');
  const navigate = useNavigate();

  const handleContinueToScan = useCallback(() => {
    navigate(`../${PATHS.verification.qrScanner}`);
  }, [navigate]);

  return (
    <div className={styles.ivQRScan_content}>
      <div className={styles.ivQRScan_iconBox}>
        <QrCode size={48} className={styles.ivQRScan_icon} strokeWidth={1.5} />
      </div>

      <h2 className={styles.ivQRScan_title}>{t('scan_qr_code_at_your_accommodation')}</h2>

      <p className={styles.ivQRScan_description}>
        <Trans i18nKey="scan_qr_code_at_accommodation_description" t={t} />
      </p>

      <Button
        label={t('continue_to_scan')}
        onClick={handleContinueToScan}
        className={styles.ivQRScan_button}
      />
    </div>
  );
}

export {IVQRScanView};
